module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deground"
  }, [_c('headerpage', {
    attrs: {
      "status": 3
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adaptation",
    staticStyle: {
      "background-color": "#f6f8f7"
    }
  }, [_c('div', {
    staticClass: "hetext"
  }, [_vm._v("首页>园区企业>详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fd0d917"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/enterprisedetail.vue
// module id = 884
// module chunks = 1